function formatDateTime(dateStr, timeStr) {
    if (!dateStr || !timeStr) return "";

    const [year, month, day] = dateStr.split("-").map(Number);
    const [hh, mm, ss] = timeStr.split(".").map(Number);

    const date = new Date(Date.UTC(year, month - 1, day, hh, mm, ss));

    const datePart = date.toLocaleDateString("en-US", {
        timeZone: "UTC",
        month: "numeric",
        day: "numeric",
        year: "numeric",
    });

    const timePart = date.toLocaleTimeString("en-US", {
        timeZone: "UTC",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true
    });

    return `${datePart} at ${timePart}`;
}

function formatUpdatedAt(updatedAt) {
    if (!updatedAt) return "";

    const safeDate = updatedAt.endsWith("Z")
        ? updatedAt
        : updatedAt + "Z";

    const date = new Date(safeDate);

    const datePart = date.toLocaleDateString("en-US", {
        timeZone: "UTC",
        month: "numeric",
        day: "numeric",
        year: "numeric",
    });

    const timePart = date.toLocaleTimeString("en-US", {
        timeZone: "UTC",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true
    });

    return `${datePart} at ${timePart}`;
}

const LastUpdated = ({ data }) => {
    const value =
        data?.lastUpdate && data?.lastUptime
            ? formatDateTime(data.lastUpdate, data.lastUptime)
            : formatUpdatedAt(data?.updatedAt);

    return (
        <p className="mb-1">
            <b>Last Updated :</b> {value}
        </p>
    );
};

export default LastUpdated;
